import { api, useCurrentUser } from '@cma/app'
import {
  UpdateBrandingMutation,
  UpdateBrandingMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useUpdateBranding() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    UpdateBrandingMutation,
    Error,
    UpdateBrandingMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation UpdateBranding($id: ID!, $input: BrandingInput!) {
          updateBranding(id: $id, input: $input) {
            errors {
              field
              message
            }
            branding {
              brandableId
              brandableType
              id
            }
          }
        }
      `
      return api<UpdateBrandingMutation, UpdateBrandingMutationVariables>({
        query,
        variables
      })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformClient',
          { id: currentUser?.account?.id || '' }
        ])
      }
    }
  )
}
